import { useTranslate } from '@growtherapy/i18n';

import { logger } from '../../datadog/logger';
import { useAtomCallbackMemoized } from '../../hooks/useAtomCallbackMemoized';
import { toast } from '../../toasts';
import { isScreenShareModeAtom } from '../../video-sdk';
import useScreenShareCallbacks, { ShareScreenOptions } from './useScreenShareCallbacks';

type SwitchToMode = (...args: ['screenshare', ShareScreenOptions] | ['screenshare']) => void;

export function useSessionModeCallbacks() {
  const t = useTranslate();
  const getIsScreenshareMode = useAtomCallbackMemoized((get) => get(isScreenShareModeAtom), []);

  const { triggerBrowserScreenShare, stopScreenShare } = useScreenShareCallbacks((error: Error) => {
    toast.error(t('telehealth-core:screenShare.thereWasAnErrorSharingYourScreen'));
    logger.error('Error starting screen share', {}, error);
  });

  function stopCurrentMode() {
    if (getIsScreenshareMode()) {
      stopScreenShare();
    }
  }

  const switchToMode: SwitchToMode = (mode, options?) => {
    stopCurrentMode();
    switch (mode) {
      case 'screenshare': {
        triggerBrowserScreenShare(options);
        break;
      }
    }
  };

  return {
    switchToMode,
    stopCurrentMode,
  };
}
